import React from "react";

export const RevenueIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  className = "w-6 h-6 text-green-600",
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {/* Outer Circle */}
         <circle
        cx="30"
        cy="30"
        r="29"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />

      {/* Wallet Icon */}
      <path
        d="M31.3335 28.8667H23.3335"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6665 28.8667V22.7067C16.6665 19.9867 18.8665 17.7867 21.5865 17.7867H29.0798C31.7998 17.7867 33.9998 19.48 33.9998 22.2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.3065 30.2667C36.6398 30.9067 36.3198 31.8933 36.5865 32.9066C36.9198 34.1466 38.1465 34.9333 39.4265 34.9333H40.6665V36.8667C40.6665 39.8133 38.2798 42.2 35.3332 42.2H21.9998C19.0532 42.2 16.6665 39.8133 16.6665 36.8667V27.5333C16.6665 24.5867 19.0532 22.2 21.9998 22.2H35.3332C38.2665 22.2 40.6665 24.6 40.6665 27.5333V29.4666H39.2265C38.4798 29.4666 37.7998 29.76 37.3065 30.2667Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.3335 30.8266V33.5733C43.3335 34.32 42.7201 34.9333 41.9601 34.9333H39.3868C37.9468 34.9333 36.6268 33.88 36.5068 32.44C36.4268 31.6 36.7468 30.8133 37.3068 30.2667C37.8001 29.76 38.4801 29.4666 39.2268 29.4666H41.9601C42.7201 29.4666 43.3335 30.08 43.3335 30.8266Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};